/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMarginPadding = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M13 18h-2v2H8v2h8v-2h-3zM4 8H2v8h2v-3h2v-2H4zm16 0v3h-2v2h2v3h2V8zM8 4h3v2h2V4h3V2H8zm0 12h8V8H8zm2-6h4v4h-4z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgMarginPadding as MarginPadding };
